import React, { useEffect, useState } from 'react';
import { FaComments } from 'react-icons/fa'; // Importa o ícone
import '../styles/CardStyles.css';

function TotalCommentsCard() {
  const [totalComments, setTotalComments] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/data`);
        const data = await response.json();

        if (data && Array.isArray(data)) {
          const total = data.reduce((acc, post) => acc + (post._source.comentarios ? post._source.comentarios.length : 0), 0);
          setTotalComments(total);
        }
      } catch (error) {
        console.error('Erro ao buscar dados:', error);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="card">
      <FaComments size={40} color="#5a7302" className="card-icon" /> {/* Adiciona o ícone */}
      <h3>Total de Comentários Coletados</h3>
      <p className="card-number">{totalComments}</p>
    </div>
  );
}

export default TotalCommentsCard;
